module.exports = __webpack_public_path__ + "img/2.7b2cf749.png";